import { useState, useMemo } from 'react';
import { Contact } from '../types/Contact';

export function useContactFilter(contacts: Contact[]) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredContacts = useMemo(() => {
    if (!searchQuery.trim()) return contacts;

    const query = searchQuery.toLowerCase();
    return contacts.filter(
      contact =>
        contact.name?.toLowerCase().includes(query) ||
        contact.caller_id.toLowerCase().includes(query)
    );
  }, [contacts, searchQuery]);

  return { filteredContacts, searchQuery, setSearchQuery };
}
